import { Box, VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';

import type { AuditLogDetailRowProps } from './AuditLogDetailRow';
import { AuditLogDetailRow } from './AuditLogDetailRow';

export type AuditLogDetailSectionProps = {
  eventId: string;
  title?: string;
  rows: AuditLogDetailRowProps[];
};

export function AuditLogDetailSection({ eventId, title, rows }: AuditLogDetailSectionProps) {
  return (
    <VStack width="100%" gap={0}>
      {title ? (
        <Box width="100%" paddingX={3} paddingY={1}>
          <Text as="span" font="headline" color="fg">
            {title}
          </Text>
        </Box>
      ) : null}
      {rows.map((row) => (
        <AuditLogDetailRow key={`${eventId}-${String(row.label)}`} {...row} />
      ))}
    </VStack>
  );
}
